import { ReactComponent as ChevronLeft } from 'assets/images/chevron-left.svg'

interface BackButtonProps {
  onClick: () => void
  style?: React.CSSProperties
}

const BackButton = ({ onClick, style }: BackButtonProps) => {
  return (
    <div
      className="d-flex align-items-center cursor-pointer"
      onClick={onClick}
      style={style}
    >
      <ChevronLeft className="nav-icon-small text-primary" />
      <p className="spaced-capital-letters mb-0 ml-2 text-primary">Back</p>
    </div>
  )
}

export default BackButton
